<template>
  <tabs>
    <div>
      <tab name="Beschreibung" :selected="true">
        <div class="flex flex-wrap">
          <div class="w-full lg:w-1/2 md:w-1/2 pt-5" v-for="(austt, key) in beschreibung" :key="key"
              v-show="austt != 0">
            <div class="pl-6">
              <div v-if="key == 'Artikel Beschreibung'">
                <span v-show="key != 0" class="font-semibold">{{ key }}:</span>
                <div class="ml-8" v-for="(aust, key) in austt" :key="key">
                  <span class="text-sm">
                    <span  class="font-normal">
                     <span class="text-teal-400 font-semibold">-</span>
                      {{ aust }}
                    </span>
                  </span>
                </div>
                <br />
              </div>
              <div v-else>
                <span v-show="key != 0" class="font-semibold">{{ key }}:</span>
                <div class="ml-8" v-for="(aust, key) in austt" :key="key">
                  <span class="text-teal-400 font-semibold">-</span>
                  <span class="text-sm">
                    {{ key }}:
                    <span v-if="key == 'Lieferumfang'">
                      <span v-for="lieferInfo in lieferInformation" :key="lieferInfo">
                        <br />
                        <!-- {{ lieferInfo}} -->
                        <span v-if="lieferInfo.includes('Front')">
                          {{ lieferInfo.substring(0, lieferInfo.indexOf('Front')) }}
                        </span>
                         <span v-else-if="productName.includes('900') && lieferInfo.includes('Top')">
                          {{ lieferInfo.substring(0, lieferInfo.indexOf('Top')) }}
                        </span>
                        <span v-else>
                          {{ lieferInfo}}
                        </span>
                      </span>
                      <br>
                      <span v-if="!productName.includes('LED-Beleuchtung')">
                        <!-- <span v-if="!productName.includes('900')">
                        Ohne LED-Beleuchtung.
                        <br>
                        </span> -->
                          Ohne Dekoration.
                      </span>
                    </span>
                    <span v-else class="font-semibold">{{ aust }}</span>
                  </span>
                </div>
                <br />
              </div>
            </div>
          </div>
        </div>
      </tab>

      <tab name="Funktionen & Qualität">
        <div class="flex flex-wrap">
          <div class="w-full lg:w-1/2 md:w-1/2 pt-5">
            <div>
              <h4 class="text-gray-900 py-2 font-semibold text-lg">Ausstattung:</h4>
              <ul class="pl-6">
                <li v-for="(austt, key) in austtatung" :key="key">
                  <span v-if="key.includes('Front')" class="font-semibold">{{ key.substring(0, key.indexOf('Front')) }}:</span>
                  <span v-else class="font-semibold">{{ key}}:</span>
                  <!-- .substring(0, str.indexOf('/')) -->
                  <ol>
                    <li class="ml-8" v-for="(aust, key) in austt" :key="key">
                      <span class="text-teal-400 font-semibold">-</span>
                      <span class="text-sm">
                        {{ key }}:
                        <span class="font-semibold">{{ aust }}</span>
                      </span>
                    </li>
                    <br />
                  </ol>
                </li>
              </ul>
            </div>
          </div>
          <div class="lg:w-1/2 md:w-1/2 pt-5">
            <div>
              <h4 class="text-gray-900 text-sm font-semibold">Qualität:</h4>
              <ul class="pl-6">
                <li class="text-sm">
                  <span class="text-teal-400 font-semibold">-</span>
                  Zertifikate:
                  <strong class="font-semibold">FSC</strong>
                </li>
                <li class="text-sm">
                  <span class="text-teal-400 font-semibold">-</span>
                  Garantie (Jahre):
                  <strong class="font-semibold">2</strong>
                </li>
              </ul>
            </div>
            <div>
              <h4 class="text-gray-900 text-sm font-semibold">Pflegehinweis:</h4>
              <ul class="pl-6">
                <p class="text-sm">
                  <span class="text-teal-400 font-semibold">-</span> Pflegeleichte, strapazierfähige und unempfindliche
                   Oberflächen.
                </p>
                <p class="text-sm">
                  <span class="text-teal-400 font-semibold">-</span> Mit feuchtem Tuch (evtl. mit mildem Reinigungsmittel)
                   abwischen.
                </p>
                <p class="text-sm">
                  <span class="text-teal-400 font-semibold">-</span> Mit einem trockenem Baumwolltuch nachwischen.
                </p>
              </ul>
            </div>
          </div>
        </div>
      </tab>

      <tab name="Lieferung & Versand">
        <div class="flex flex-wrap">
          <div class="lg:w-1/3 md:w-auto pt-5">
            <div class="pl-6">
              <ul>
                <li v-if="product.product_shop" class="text-sm text-gray-900 py-1">
                  Lieferzeit:
                  <span
                    class="text-teal-400 font-bold"
                  >
                   <!-- 1-2 Wochen -->
                  {{ product.product_shop.product.delivery_weeks }}
                  </span>
                  <!-- <span v-else class="text-teal-400 font-bold">0</span> -->
                </li>
                <li>
                  <span class="text-gray-900 text-sm">Lieferung bis in die Wohnung</span>
                </li>
              </ul>
            </div>
          </div>
          <div class="lg:w-1/3 md:w-auto pt-5">
            <div class="pl-6">
              <ul>
                <li>
                  <span
                    class="text-gray-900 text-sm"
                  >Kostenfreie 2-Mann-Profi-Lieferung bis in deine Wohnräume.</span>
                </li>
              </ul>
            </div>
          </div>
          <div class="lg:w-1/3 md:w-auto pt-5">
            <div class="pl-6">
              <ul>
                <li>
                  <span
                    class="text-gray-900 text-sm"
                  >Dieser Artikel wird per Möbelspedition geliefert. Für dich bedeutet das:</span>
                </li>
              </ul>
            </div>
          </div>
          <div class="w-full">
            <hr class="w-full border-b-2 mt-4" />
          </div>
          <div class="lg:w-1/3 md:w-auto pt-5">
            <div class="pl-6">
              <ul>
                <li class="text-gray-900 text-md font-semibold">Die Versandkosten gehen auf uns</li>
                <li>
                  <span class="text-gray-900 text-sm">
                    Die Lieferung ist für dich kostenlos, die Summe deines Warenkorbs ist auch der Endpreis.
                    Einen Aufpreis für den Versand zahlst du nur, wenn du Zusatzleistungen wünschst.
                    Diese kannst du gegebenenfalls bei der telefonischen Terminabsprache mit der Spedition vereinbaren.
                  </span>
                </li>
              </ul>
            </div>
          </div>
          <div class="lg:w-1/3 md:w-auto pt-5">
            <div class="pl-6">
              <ul>
                <li class="text-gray-900 text-md font-semibold">Lieferinformationen</li>
                <li>
                  <span class="text-gray-900 text-sm">
                    Wenn die Lieferung versandbereit ist, wird sich die Spedition telefonisch mit dir in Verbindung setzen, um den Liefertermin zu vereinbaren. Den möglichen Zeitraum erfährst du im Gespräch
                    Dein neues Möbelstück wird von den Lieferanten bis direkt an den Ort gebracht, wo du es in deiner Wohnung aufstellen willst. Bitte stelle vorher sicher, dass dort genug Platz dafür ist.
                    Deine Adresse muss mit dem LKW angesteuert werden können. Bitte informiere den Spediteur bei der Terminvereinbarung, falls die Wege bis zu deiner Haustür nicht von LKW befahrbar sind, z.B. in Fußgängerzonen, durch Baustellen etc. Einschränkungen (wie z.B. durch zu schmale Treppenhäuser) sind vorbehalten. Zusätzliche Dienstleistungen wie das Entsorgen alter Möbel oder Verpackungen oder der Montageservice sind nicht Teil der homeface Lieferung.
                    
                  </span>
                </li>
              </ul>
            </div>
          </div>
          <div class="lg:w-1/3 md:w-auto pt-5">
            <div class="pl-6">
              <ul>
                <li class="text-gray-900 text-md font-semibold">Informationen zum Lieferumfang</li>
                <li>
                  <span class="text-gray-900 text-sm">
                    Der Artikel wird wie beschrieben geliefert.
                    Andere Dekorationsgegenstände auf den Produktbildern sind nicht im Lieferumfang enthalten.
                    <br>
                    Ohne Dekoration. <br>
                    Ohne LED-Beleuchtung.
                  </span>
                </li>
                <br>
                <li class="text-gray-900 text-md font-semibold">Zusatzinformation</li>
                <li>
                  <span class="text-gray-900 text-sm">
                    Die Möbel werden in Paketen mit Montageanleitung zum Selbstaufbau geliefert.
                    Geliefert wird nicht auf Insel und Bergbewohnung. 
                  </span>
                </li>
              </ul>
            </div>
          </div>
          <div class="w-full">
            <hr class="w-full border-b-2 mt-4" />
          </div>
        </div>
      </tab>

      <tab name="Montageanleitung">
        <h1 class="p-3 font-semibold text-gray-900">Montageanleitung:</h1>
        <ul class="pl-6">
          <li class="list-disc text-teal-400" v-for="pdfFiles in pdf" :key="pdfFiles.id">
            <a
              :href="pdfFiles.path"
              target="_blank"
              class="text-teal-400 hover:text-teal-300"
            >{{ pdfFiles.name }} (pdf)</a>
          </li>
        </ul>
      </tab>

      <tab name="Bewertungen">
          <form v-if="!rated" @submit.prevent="addRating" class="py-8">
            <div class="flex py-2">
              <label class="text-gray-900 font-semibold">{{ $t("Ratings") }}:</label>
              <StarRating class="ml-10" :show-rating="false" :star-size="25" v-model="rating"></StarRating>
            </div>
            <div class="py-2">
              <label class="comment text-gray-900 font-semibold">{{ $t("Comment") }}:</label>
              <textarea
                required
                cols="20"
                rows="5"
                class="border border-gray-500 ml-16 outline-none"
                v-model.trim="comment"
              ></textarea>
            </div>
            <div class>
              <button
                class="border bg-teal-400 text-white font-semibold px-4 py-1 rounded shadow hover:bg-white hover:text-teal-400"
              >{{ $t("Ratings") }}</button>
            </div>
          </form>
          <form v-if="this.editing" @submit.prevent="edit(productRating.id)" class="py-8">
            <div class="flex py-2">
              <label class="text-gray-900 font-semibold">{{ $t("Ratings") }}:</label>
              <StarRating class="ml-10" :show-rating="false" :star-size="25" v-model="productRating.rating"></StarRating>
            </div>
            <div class="py-2">
              <label class="comment text-gray-900 font-semibold">{{ $t("Comment") }}:</label>
              <textarea
                required
                cols="20"
                rows="5"
                class="border border-gray-500 ml-16 outline-none"
                v-model.trim="productRating.description"
              ></textarea>
            </div>
            <div class>
              <button
                class="border bg-teal-400 text-white font-semibold px-4 py-1 rounded shadow hover:bg-white hover:text-teal-400"
              >{{ $t("Ratings") }}</button>
            </div>
          </form>

        <div v-if="!this.editing">
          <div class=" py-4" v-for="rating in ratings" :key="rating.id">
            <div>
              <StarRating
                class=""
                :show-rating="false"
                :star-size="25"
                :read-only="true"
                v-model="rating.rating"
              ></StarRating>
            </div>
            <div>
              <p class="inline pr-2 text-gray-900 text-xl font-semibold">{{ rating.user }}</p>
              <p class="inline text-gray-900 text-xs">{{ rating.date }}</p>
            </div>
            <div class="py-2">
              <p class="text-gray-900 text-md inline-block">{{ rating.description }}</p>
                <span v-if="rating.rated" class="pl-4 cursor-pointer" @click="getRating(rating.id)">
                  <i class="text-right text-lg far fa-edit text-teal-400 hover:cursor-pointer hover:text-teal-200"></i>
                </span>
                <span v-if="rating.rated" class="pl-4 cursor-pointer" @click="$emit('delete-rating', rating.id, rating)">
                  <i class="text-right text-lg fas fa-trash text-teal-400 hover:cursor-pointer hover:text-teal-200"></i>
                </span>
            </div>
            <hr>
          </div>
        </div>
      </tab>
    </div>
  </tabs>
</template>

<script>
import tabs from "./Tabs";
import tab from "./Tab";
import StarRating from "vue-star-rating";
import axios from "axios";

export default {
  components: {
    tab,
    tabs,
    StarRating,
  },
  props: {
    id: Number,
    beschreibung: Object,
    lieferInformation: Array,
    austtatung: Object,
    product: Object,
    pdf: Array,
    code: String,
    ratings: Array,
    rated: Boolean,
    productName: String
  },
  data() {
    return {
      // pdf: "",
      // code: ""
      // product_id: this.product.product_shop.product.id,
      // productName: "",
      rating: 0,
      comment: "",
      error: false,
      editing: false,
      productRating: {}
    };
  },
  computed: {
    getBeschreibung() {
      return this.beschreibung;
    },
    getlieferInformation() {
      return this.lieferInformation;
    },
    getAusttatung() {
      return this.austtatung;
    },
    getProduct() {
      return this.product;
    },
    getPdf() {
      return this.pdf;
    },
    getCode() {
      return this.code;
    },
    getRatings() {
      return this.ratings
    },
    getRated() {
      return this.rated;
    },
    getProductName()
    {
      return this.productName;
    }
  },
  created() {
    // console.log('asdas');
    
    // console.log(this.product.product_shop.name);
    // this.product_name();
  },
  methods: {
    isEmpty(product) {
      return Object.keys(product).length === 0;
    },
    addRating() {
      // axios.defaults.headers.common["Authorization"] =
      //   "Bearer " + localStorage.getItem("access_token");

      //   axios
      //     .post(`${process.env.VUE_APP_API}/ratings`, {
      //       product_id: this.product.product_shop.product.id,
      //       rating: this.rating,
      //       description: this.comment,
      //     })
      //     .then(() => {
      //       if(!this.error) {
      //         this.$notify({
      //           group: "cart",
      //           title: "Homeface",
      //           text: "Vielen Danke!",
      //         })
      //       }

      //       location.reload();
      //     })
      //     .catch((error) => {
      //       console.log(error)
      //         this.$notify({
      //           group: "cart",
      //           title: "Homeface",
      //           text: "Nicht Authentifiziert!",
      //         })
      //       this.error = true
      //     });

      const rate = {
        product_id: this.product.product_shop.product.id,
        rating: this.rating,
        description: this.comment,
      }

      this.$emit('add-new-rate', rate);
    
      this.clearRate();
      
      // location.reload();
    },
    clearRate() {
      this.rating = 0;
      this.comment = "";
    },
    getRating(id) {
      this.editing = true;

      axios.defaults.headers.common["Authorization"] =
        "Bearer " + localStorage.getItem("access_token");
      
      axios.get(`${process.env.VUE_APP_API}/rating/${id}`)
        .then(response => {
          // console.log(response)
          this.productRating = response.data;
          // this.editing = true;
        }).catch(error => {
          console.log(error)
        })

    },
    edit(id) {

      const rate = {
        product_id: this.product.product_shop.product.id,
        rating: this.productRating.rating,
        description: this.productRating.description
      }

      this.$emit('edit-rating',id ,rate);
      this.editing = false;

    },
    // product_name(){
      
    //   this.productName = this.product.product_shop.name;
    //   console.log('as');
    //   console.log(this.productName);
    // },
  },
};
</script>

<style scoped>
.comment {
  vertical-align: top;
}
</style>
